<template>
  <div v-if="answer">
    <div>
      <p><mdb-icon icon="chart-line" /> 점수 : {{ answer.score.toFixed(2) }} 점</p>
      <p>
        <mdb-icon far icon="circle" /> 정답수 : {{ answer.correctCount}} 개<br>
        <mdb-icon icon="times" /> 오답수 : {{ answer.answers.length - answer.correctCount}} 개
      </p>
    </div>
    <hr/>
    <div v-for="(q, i) in questions" :key="i" class="mb-3">
      <question-view :question="q" :answer="answer.answers[i]" :num="i"/>
    </div>
  </div>
</template>
<script>
import QuestionView from '../QuestionView.vue'
export default {
  name: 'PreWritingTestView',
  components: { QuestionView },
  props: ['questions', 'answer']
}
</script>
